import React, { useEffect, useReducer, useState } from "react";
import {
  Table,
  UncontrolledDropdown,
  Progress,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import style from "../style.module.scss";
import CircularProgress from "../../../CircularProgress/CircularProgress";
import CustodianEntity from "../../CustodianEntity/CustodianEntity";
import {
  CounterPartySimpleReducer,
  defaultState,
  initialize,
  validateForm,
} from "../../CounterPartySet/reducer";
import { addDay, addMonth, DateField, toFormatDate } from "../../../../utils";
import CounterParty from "../../CounterPartySet/CounterParty";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";

const initialState = {
  dropdownMonthOpen: false,
  counterparties: [],
  loadingCP: true,
  custodians: [],
  loadingCU: true,
  topMonthSelected: 10,
  selectedCP: {
    id: 0,
    name: undefined,
  },
  selectedCU: {
    id: 0,
    name: undefined,
  },
  counterpartiesSuggested: [],
  searchBar: "",
  fromDate: addMonth(new Date(), -1).toLocaleDateString("en"),
  toDate: addDay(new Date(), 5).toLocaleDateString("en"),
  openCounterParty: false,
  loadingCountry: false,
  countries: [],
  clearinghouses: [],
  countriesloading: false,
  clearinghousesloading: false,
  counterPartyId: 0,
};

const GridCounterParty = ({ rows, loading, selectedCP, selectCP, Flag, ...props }) => {
  const [state, setState] = useState(initialState);

  const CounterPartyForm = (id) => {
    setState({
      ...state,
      openCounterParty: true,
      loadingCountry: true,
      countriesloading: true,
      clearinghousesloading: true,
      counterPartyId: id,
    });
    props.fetchs.getCountryCounterParty().then((r) => {
      setState({
        ...state,
        openCounterParty: true,
        countries: r.countries,
        countriesloading: false,
      });
    });
    props.fetchs.getClearingHouseCounterParty().then((c) => {
      setState({
        ...state,
        openCounterParty: true,
        clearinghouses: c.clearingHouses,
        clearinghousesloading: false,
      });
    });
  };

  const onClickClose = () => {
    setState({
      ...state,
      openCounterParty: false,
    });
  };

  return (
    <Table responsive>
      <thead>
        <tr>
          <th>
            <i className="fa fa-th-list"></i>
          </th>
          <th>Counter Party</th>
          {
            //<th>Country</th>
          }
          <th>Usage</th>
          <th>Failing YOY</th>
          <th>Successful YOY</th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan={6}>
              <CircularProgress />
            </td>
          </tr>
        ) : (
          rows.map((d, i) => {
            return (
              <tr key={i}>
                <td>
                  <UncontrolledDropdown>
                    <DropdownToggle tag="a">
                      <i className="fa fa-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem active={selectedCP == d.Id} onClick={() => selectCP(d.Id, d.Name)}>
                        Check Trades
                      </DropdownItem>
                      <DropdownItem active={selectedCP == d.Id} onClick={() => CounterPartyForm(d.Id)}>
                        Edit Counter Party
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </td>
                <td>{d.Name}</td>
                {/*<td>
                  <Flag style={{width: "70px"}} code={d.CountryIso} />
                </td>*/}
                <td>
                  <div style={{ width: "100%" }}>
                    <strong>{parseFloat(d.percentage)}%</strong>
                    <small className="float-right">
                      {parseFloat(d.creditLine)} / {parseFloat(d.Limits)}K
                    </small>
                  </div>
                  <Progress color="info" value={parseFloat(d.percentage)} max="100" />
                </td>
                <td>
                  <p className="text-muted">
                    {" "}
                    <small>{d.failingnumber} trades</small>
                  </p>
                  <p className="text-red">
                    {" "}
                    <strong>
                      USD <FormattedNumber value={d.falingUSDYOY} dataTypeDecimalName="currency" />
                    </strong>
                  </p>
                </td>
                <td>
                  <p className="text-muted">
                    {" "}
                    <small>{d.trades} trades</small>
                  </p>
                  <p>
                    {" "}
                    <strong>
                      USD <FormattedNumber value={d.tradesUSDYOY} dataTypeDecimalName="currency" />
                    </strong>
                  </p>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
      {state.openCounterParty && (
        <CounterParty
          open={state.openCounterParty}
          countries={state.countries}
          clearinghouses={state.clearinghouses}
          onClickClose={onClickClose.bind(this)}
          callApiProxy={props.callApiProxy}
          countriesloading={state.countriesloading}
          clearinghousesloading={state.clearinghousesloading}
          fetchs={props.fetchs}
          editCounterParty={true}
          counterPartyId={state.counterPartyId}
        />
      )}
    </Table>
  );
};
export default GridCounterParty;
